<template>
    <div class="profile-latest-update">
      <div v-if="loading">
        Loading latest update...
      </div>
      <div v-else-if="error">
        {{ error }}
      </div>
      <div v-else-if="article">
        <img :src="article.headImage" alt="Blog Header Image" class="head-image" />
        <h3>{{ article.title }}</h3>
        <!-- Render article.description as HTML -->
        <p v-html="article.description"></p>
      </div>
      <div v-else>
        <p>No updates available.</p>
      </div>
    </div>
  </template>
  
  <script>
  import { db } from "../firebaseConfig";
  import { collection, getDocs, query, orderBy, limit } from "firebase/firestore";
  
  export default {
    name: "ProfileLatestUpdate",
    data() {
      return {
        article: null,
        loading: false,
        error: null
      };
    },
    created() {
      this.fetchLatestArticle();
    },
    methods: {
      async fetchLatestArticle() {
        this.loading = true;
        try {
          const blogRef = collection(db, "devBlog");
          // Assuming each article has a "timestamp" field so we can order them (newest first)
          const q = query(blogRef, orderBy("timestamp", "desc"), limit(1));
          const snapshot = await getDocs(q);
          if (!snapshot.empty) {
            const docSnap = snapshot.docs[0];
            this.article = { id: docSnap.id, ...docSnap.data() };
          }
        } catch (err) {
          console.error("Error fetching latest blog update:", err);
          this.error = "Failed to load the latest update.";
        } finally {
          this.loading = false;
        }
      }
    }
  };
  </script>
  
  <style scoped>
  .profile-latest-update {
    max-width: 350px;
    min-width: 250px;
    margin-bottom: 30px;
    border-radius: 30px;
    background-color: #fff;
    border: 1px solid #C9BF9B;
    box-shadow: 0px 4px 4px #c9bf9b54;
  }
  .profile-latest-update p {
    font-size: 0.8rem;
    padding: 0px 20px 1px 20px;
  }
    .profile-latest-update h3 {
    font-size: 1.2rem;
    padding: 5px 20px 15px 20px;
    margin-bottom: -1rem;
    margin-top: 0rem;
    }
  .head-image {
    width: 100%;
    max-height: 200px;
    object-fit: cover;
    margin-bottom: 10px;
    border-radius: 30px 30px 0px 0px;
  }
  </style>
  